import React from 'react';
import {
    formatter, formatterDecimal
} from "../../../../utils/common";

const Widget = ({ textColorClass, value, label, isShowSale, saleAmount, isShowReturn, returnAmount }) => {
    textColorClass = textColorClass ? textColorClass : 'text-dark';
    return (
        <div className="col-md-6 col-xl" style={{ padding: 6 }}>
            <div className="summary-box">
                <div className="summary-box-body text-right">
                    <h6 className="text-truncate sb-title">{label}</h6>
                    <h5 className={`sm-value ${textColorClass}`}>{value}</h5>
                </div>

                {(isShowSale || isShowReturn) && (
                    <div className="summary-box-footer">
                        {isShowSale ? (
                            <div className="sbf-item sbf-item-left text-center">
                                <small className="text-muted">Sale</small>
                                <div className="font-weight-bold">{saleAmount}</div>
                            </div>
                        ) : null}

                        {isShowReturn ? (
                            <div className="sbf-item sbf-item-right text-center">
                                <small className="text-muted">Return</small>
                                <div className="font-weight-bold">{returnAmount}</div>
                            </div>
                        ) : null}
                    </div>
                )}
            </div>
        </div>
    );
};


const ProductCostTotalSummary = ({ financesSummaryState }) => {
    const totalRow = financesSummaryState.productCostDetailsTableRow;
    const totalSummary = financesSummaryState.productCostDetailsTotalSummary;

    const totalSaleCost = Number(totalSummary?.total_sale_cost || 0);
    const totalReturnCost = Number(totalSummary?.total_return_cost || 0);
    const totalTaxSale = Number(totalSummary?.total_tax_sale_cost || 0);
    const totalTaxReturn = Number(totalSummary?.total_tax_return_cost || 0);
    const totalNetSale = Number(totalSummary?.total_net_sale_cost || 0);
    const totalNetReturn = Number(totalSummary?.total_net_return_cost || 0);

    const widgetsData = [
        {
            value: totalRow,
            label: "Total Records",
        },
        {
            textColorClass: 'text-success',
            value: formatter.format(totalSaleCost + totalReturnCost),
            label: "Total Gross Cost",
            isShowSale: true,
            saleAmount: formatter.format(totalSaleCost),
            isShowReturn: true,
            returnAmount: formatter.format(totalReturnCost),
        },
        {
            value: formatter.format(totalTaxSale + totalTaxReturn),
            label: "Total Tax",
            isShowSale: true,
            saleAmount: formatter.format(totalTaxSale),
            isShowReturn: true,
            returnAmount: formatter.format(totalTaxReturn),
        },
        {
            value: formatter.format(totalNetSale + totalNetReturn),
            label: "Total Net Cost",
            isShowSale: true,
            saleAmount: formatter.format(totalNetSale),
            isShowReturn: true,
            returnAmount: formatter.format(totalNetReturn),
        },
        {
            textColorClass: 'text-danger',
            value: formatter.format(totalTaxSale + totalTaxReturn),
            label: "Difference with Shopify",
        },
    ];

    return (
        <div className="row" style={{ marginLeft: -6, marginRight: -6 }}>
            {widgetsData.map((widget, index) => (
                <Widget
                    key={index}
                    textColorClass={widget.textColorClass}
                    value={widget.value}
                    label={widget.label}
                    isShowSale={widget.isShowSale}
                    saleAmount={widget.saleAmount}
                    isShowReturn={widget.isShowReturn}
                    returnAmount={widget.returnAmount}
                />
            ))}
        </div>
    );
};

export default ProductCostTotalSummary;
